function hashFunc(str: string, size: number) {
  let hashCode = 0;
  for (let i = 0; i < str.length; i++) {
    hashCode = 37 * hashCode + str.charCodeAt(i); //获取编码
  }
  return hashCode % size;
}

export function getDimensionColor(dimensionKey: string) {
  // 颜色列表
  const tagColorList = [
    {
      "background-color": "#ebedff",
      color: "#5c64ac"
    },
    {
      "background-color": "#ffefff",
      color: "#9e55a0"
    },

    {
      "background-color": "#ffe0eb",
      color: "#a85972"
    },
    {
      "background-color": "#fef1c2",
      color: "#b98a4b"
    },
    {
      "background-color": "#d4f5ea",
      color: "#3f9f82"
    },
    {
      "background-color": "#d0f1fe",
      color: "#4a7e92"
    },
    {
      "background-color": "#fce4e2",
      color: "#d57e77"
    },
    {
      "background-color": "#f4ffce",
      color: "#849b38"
    },
    {
      "background-color": "#dfffda",
      color: "#699162"
    },
    {
      "background-color": "#ffe6c8",
      color: "#a2753d"
    }
    // {
    //   "background-color": "#ebedff",
    //   color: "#5c64ac"
    // },
    // {
    //   "background-color": "#ffefff",
    //   color: "#9e55a0"
    // },
    // {
    //   "background-color": "#ffe0eb",
    //   color: "#a85972"
    // }
  ];

  const colorConfig = tagColorList[hashFunc(dimensionKey, tagColorList.length)];
  return colorConfig;
}
